module.exports = __webpack_public_path__ + "img/qiji-QR.aeca7390.png";